import type { MapItemWithCoodId } from "@/types/search";

/**
 * Check if an array of projects/markers has any actual properties (SUPs)
 *
 * @param projects - Array of map items with coordinates
 * @returns true if any project has SUPs, false otherwise
 */
export function hasProjectsWithSUPs(projects: MapItemWithCoodId[]): boolean {
	return projects.some(project => project.sups && project.sups.length > 0);
}
